import React from 'react';
import { Checkbox, Stack, TableCell, Typography } from "@mui/material";
import { useProductSettingsContext } from "../context/ProductSettingsContext";
import { SalesGeographyInMarketDatePicker } from "./SalesGeographyInMarketDatePicker";
import { SalesGeographyEndInMarketDatePicker } from "./SalesGeographyEndInMarketDatePicker";
import PropTypes from 'prop-types';
import { SETTINGS_GRID_CELL_PADDING, SETTINGS_GRID_SPANNED_COLUMN_COUNT } from '../../../Utilities/settingsGridColumns';

const enableInMarketDate = process.env.REACT_APP_ENABLE_IN_MARKET_DATE === 'true';
const enableSeasonalForecast = process.env.REACT_APP_ENABLE_SEASONAL_FORECAST === 'true';

export const RegionRow = ({ row }) => {
    const { onRowSelectClick, isRowSelected, isRowCheckboxIndeterminate } = useProductSettingsContext();

    return (<React.Fragment>
        <TableCell sx={{ padding: SETTINGS_GRID_CELL_PADDING }} colSpan={SETTINGS_GRID_SPANNED_COLUMN_COUNT} className="Region">
            <Stack direction='row' alignItems='center'>
                <Checkbox
                    id={row.id}
                    color="primary"
                    indeterminate={isRowCheckboxIndeterminate(row)}
                    checked={isRowSelected(row)}
                    onChange={event => onRowSelectClick(row, event.target.checked)} />
                <Typography
                    sx={{ marginLeft: '32px' }}>{row.id}</Typography>
            </Stack>
        </TableCell>
        {enableInMarketDate && <SalesGeographyInMarketDatePicker row={row} className="Region" />}
        {enableInMarketDate && enableSeasonalForecast && <SalesGeographyEndInMarketDatePicker row={row} className="Region" />}
    </React.Fragment>)
}

RegionRow.propTypes = {
    row: PropTypes.object,
}
